import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckboxInput, ErrorList, Typography, } from '@guildeducationinc/recess';
import { useAuth } from '@src/hooks/useAuth';
import { getLocalizedContentValue } from '@src/utilities/contentHelper';
import { getFullName } from '@src/utilities/nameHelper';
import { uniq } from 'lodash';
import { RichTextViewer, TextInput, useLocale } from 'pe-core-frontend';
import styles from './Attestations.module.scss';
export const Attestations = ({ contents, attestationContentIds, setAttestationContentIds, signature, setSignature, errors, readonly, }) => {
    const { t } = useLocale();
    const { currentUser } = useAuth();
    const getText = (content) => getLocalizedContentValue(content, currentUser?.clientInfo?.locale, content.name);
    const handleCheckChange = (contentId) => (e) => {
        if (e.target.checked) {
            setAttestationContentIds(uniq([...attestationContentIds, contentId]));
        }
        else {
            setAttestationContentIds(attestationContentIds.filter(id => id !== contentId));
        }
    };
    return (_jsxs("div", { className: styles.container, children: [_jsx(Typography, { variant: 'title2', weight: '300', children: t('Agreements') }), contents.map(content => (_jsxs("div", { className: styles.attestation, children: [_jsx("div", { className: 'weglot-exclude', children: _jsx(RichTextViewer, { html: getText(content) }) }), _jsx(CheckboxInput, { disabled: readonly, label: t('I accept the terms of this agreement'), checked: attestationContentIds.includes(content.id), onChange: handleCheckChange(content.id) })] }, content.id))), errors?.attestations && _jsx(ErrorList, { show: true, errors: errors.attestations }), !readonly && (_jsx(TextInput, { label: t('Signature'), required: true, value: signature, helpText: t('Type your full name ({fullName})', {
                    values: { fullName: getFullName(currentUser ?? {}) },
                }), onChange: e => setSignature(e.target.value), errors: errors?.signature, disabled: readonly }))] }));
};
